import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useOpenItemPage } from '#features/work-items/item-navigation';
import { WorkItemList } from '#features/work-items/components/work-item-list';
import { workItemSearchSchema, type WorkItemSearch } from '#features/work-items/search-schema';

/** Mis tareas abiertas en todos los proyectos: el `assignee=me` lo resuelve el servidor. */
const MyRoute = () => {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const openItemPage = useOpenItemPage();

  const onSearchChange = (patch: Partial<WorkItemSearch>): void => {
    const replace = 'q' in patch || 'item' in patch;
    void navigate({ search: (prev) => ({ ...prev, ...patch }), replace });
  };

  return (
    <WorkItemList
      search={{ ...search, assignee: search.assignee ?? ['me'] }}
      onSearchChange={onSearchChange}
      onExpand={openItemPage}
    />
  );
};

export const Route = createFileRoute('/_authed/my')({
  validateSearch: workItemSearchSchema,
  component: MyRoute,
});
